module.exports = __webpack_public_path__ + "img/sinobest.5328215d.png";